import { Route, Navigate, Routes, HashRouter } from 'react-router-dom'
import React, { Suspense, lazy } from 'react'
import { ToastContainer } from 'react-toastify'
import { getToken } from '../../Reducers/storageApp'

import Login from '../../Pages/Login'
import Interacao from '../../Pages/Interacao'
import Dash from '../../Pages/Dash'
// import Plugin from '../../Plugin/App'

const Settings = lazy(() => import('../../Pages/Settings'))

const PrivateRoute = ({ component: Component }) => {
  const token = getToken()
  if (!token) return (window.location.href = '/#/Login')
  return Component
}

export default function App() {
  return (
    <>
      <Suspense
        fallback={
          <div className="loader-container">
            <div className="loader-container-inner">
              <h6 className="mt-3">
                Aguarde enquanto carregamos todos os componentes
                <small> ... </small>
              </h6>
            </div>
          </div>
        }
      >
        <HashRouter>
          <Routes>
            {/* <Route path="/Plugin" exact element={<Plugin />} /> */}
            <Route path="/" exact element={<PrivateRoute component={<Dash />} />} />
            <Route path="/Dash" element={<PrivateRoute component={<Dash />} />} />
            <Route path="/Interacao/*" element={<PrivateRoute component={<Interacao />} />} />
            <Route path="/Settings/*" element={<PrivateRoute component={<Settings />} />} />
          </Routes>

          <Routes>
            <Route exact path="/" element={<PrivateRoute component={<Navigate to="/Dash" />} />} />
            <Route path="/login/*" element={<Login />} />
          </Routes>
        </HashRouter>
      </Suspense>

      <ToastContainer />
    </>
  )
}
